import {Component, Inject, ViewChild} from '@angular/core';
import {UrlHelper} from "../../../../helpers/url-helper";
import {HttpClient} from "@angular/common/http";
import {ServerEndpoints} from "../../../../server.endpoints";
import {Observable} from "rxjs";
import {GlobalAlertService} from "../../../../_services/global-alert.service";
import {AlertLevel} from "../../../../enums/alert-level";
import {NgxOtpInputComponent, NgxOtpInputComponentOptions, NgxOtpStatus} from "ngx-otp-input";
import {Router, RouterLink} from "@angular/router";
import {delay} from "../../../../helpers/delay-helper";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-submission',
  templateUrl: './submission.component.html',
  imports: [
    CommonModule,
    FormsModule,
    NgxOtpInputComponent,
    RouterLink
  ],
  styleUrl: './submission.component.scss'
})
export class SubmissionComponent {
  @ViewChild('otp') otp: NgxOtpInputComponent | undefined;
  protected id: string;
  protected comments: boolean = false;
  protected comment: string = "";
  protected popupVisible: boolean = false;
  protected confirmation: boolean = false;
  protected isError: boolean | undefined;
  protected readonly NgxOtpStatus = NgxOtpStatus;
  protected status: NgxOtpStatus | undefined;
  protected options: NgxOtpInputComponentOptions = {
    autoFocus: true
  }
  private token: string;

  constructor(@Inject("BASE_URL") private url: string, private httpClient: HttpClient,
              private gas: GlobalAlertService, private router: Router) {
    this.id = UrlHelper.QueryParams.id;
    this.token = UrlHelper.QueryParams.token;

    this.httpClient.get<Observable<boolean>>(`${this.url}${ServerEndpoints.Token_Basic__v2025_4}?reference=${this.id}&token=${this.token}`)
      .withLoadingIndicator()
      .subscribe({
        next: response => {
          if (!response) this.setError();
          else this.setSuccess();
        },
        error: error => {
          console.error(error);
          this.setError();
        }
      })
  }

  protected requestConfirmationCode() {
    this.popupVisible = true;
    this.httpClient.post<Observable<any>>(`${this.url}${ServerEndpoints.Token_Basic__v2025_4}?reference=${this.id}&token=${this.token}`, {})
      .subscribe({
        next: response => {
        },
        error: err => {
          console.error(err);
          this.gas.createAndShow("Fehler", "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.", AlertLevel.error);
        }
      })
  }

  protected send(code: string) {
    this.httpClient.put<Observable<boolean>>(`${this.url}${ServerEndpoints.Mailing_Submission__v2025_4}?token=${this.token}&reference=${this.id}`, {
      confirmationCode: code,
      approved: !this.comments,
      comments: this.comment
    })
      .withLoadingIndicator()
      .subscribe({
        next: response => {
          if (response) {
            this.status = NgxOtpStatus.SUCCESS;
            delay(3000).then(() => {
              this.router.navigate(['/']).then()
            });
          } else {
            this.reset();
          }
        },
        error: err => {
          console.error(err);
          this.reset();
        }
      })
  }

  protected validateSubmission(): boolean {
    if (this.comments && this.comment.isNullOrWhitespace()) {
      return false;
    }
    return this.confirmation;
  }

  protected otpChanged() {
    this.status = undefined;
  }

  private reset() {
    this.status = NgxOtpStatus.FAILED;
    this.gas.createAndShow("Fehler", "Die Bestätigung ist fehlgeschlagen. Bitte versuchen Sie es erneut.", AlertLevel.error);
    delay(2000).then(() => {
      this.otp?.reset();
      this.options.autoFocus = false;
      this.options.autoFocus = true;
    })
  }

  private setError() {
    this.isError = true;
  }

  private setSuccess() {
    this.isError = false;
  }
}
